import { FormState, FieldState } from 'formstate'
import { required } from '../../utils/forms'

export class EnduserChangePasswordForm {
  fields = {
    old_password: new FieldState('').validators(required),
    new_password: new FieldState('').validators(required),
    new_password_confirm: new FieldState('').validators(required),
  }

  form = new FormState(this.fields)

  serialize = () => {
    return {
      old_password: this.fields.old_password.$,
      new_password: this.fields.new_password.$,
    }
  }
}
